import React from 'react';
import { useReframe } from 'nike-re-framejs';
import { MatchTimer } from 'nike-ui/src/components/turboLive/components/MatchTimer';
import {
    MatchDetailOpponnets,
    MatchDetailPeriods
} from 'nike-ui/src/components/turboLive/components/detail/MatchDetailScoreboard';
import { isRainDelayExtra, getScoreboardType } from 'nike-ui/src/components/turboLive/matchExtras';
import { SvgIcon } from 'nike-ui/src/icons/SvgIcon';
import i18n from 'nike-ui/src/common/i18n';
import { match$$ } from 'nike-ui/src/components/turboLive/push/overview/subs';
import { LiveMatchOptions } from '@/matchOptions/MatchOptionsButton';
import { BetCount } from '@/nikeone/NikeOneCommon';
import { localizeMap } from 'nike-ui/src/components/turboLive/utils';
import { MatchMediaProvider } from 'nike-ui/src/components/turboLive/hooks/useMatchMedia';
import TurboLiveProvider from '@/turbo-live/context/TurboLiveProvider';
import { isVideoStream } from 'nike-ui/src/components/turboLive/push/overview/handlers';
import { MatchLiveSign } from 'nike-ui/src/components/turboLive/components/Match';

export function HybridScoreboard({ matchId, sportId, goToDetail }) {
    const derefSub = useReframe();
    const match = derefSub(match$$(null, matchId));
    if (!match) {
        return null;
    }
    const score = match.get('score');
    const isRainDelay = isRainDelayExtra(match);
    const homeOpponent = localizeMap(match.get('home'));
    const awayOpponent = localizeMap(match.get('away'));
    const eventName = `${homeOpponent}${awayOpponent ? ` vs ${awayOpponent}` : ''}`;
    const videoId = isVideoStream(match);
    return (
        <TurboLiveProvider>
            <MatchMediaProvider>
                <div className="c-black-100" onClick={e => goToDetail(e, eventName)}>
                    <div className="flex items-center justify-between">
                        <MatchDetailOpponnets
                            home={match.get('home')}
                            away={match.get('away')}
                            scores={score?.get('scores')}
                            server={score?.get('server')}
                            stats={match.get('stats')}
                            hybrid
                        />

                        <div>
                            {match.get('betCount') ? (
                                <span className="fs-14">
                                    <BetCount betCount={match.get('betCount')} />{' '}
                                </span>
                            ) : null}
                            <LiveMatchOptions eventId={match.get('id')} pureLive />
                        </div>
                    </div>

                    <div className="flex">
                        <MatchLiveSign otherClass={'mr-5'} />
                        {videoId ? <div className="icon-default-small icon-default-small-video-stream" /> : null}
                        <MatchTimer
                            scoreboardTypeId={getScoreboardType(match)}
                            matchTimer={match.get('timer')}
                            otherClass="fs-12 c-black-50"
                        />
                        {isRainDelay && (
                            <SvgIcon
                                imgId="real-cloud"
                                sizeX="14"
                                sizeY="14"
                                className="ml-10 c-red"
                                title={i18n('nui.turbo.live.match.rainDelay')}
                            />
                        )}
                        <MatchDetailPeriods
                            periodScores={score?.get('periodScores')}
                            sportId={parseInt(sportId)}
                            hybrid
                        />
                    </div>
                </div>
            </MatchMediaProvider>
        </TurboLiveProvider>
    );
}
